/** HyperPay 接口文档 mc 错误码（通用 + 业务） */
export const HYPERPAY_MC_CODES = [
  "NOT_LOGIN",
  "NO_PERMISSION",
  "PARAM_ERROR",
  "USER_NOT_FOUND",
  "SYSTEM_ERROR",
  "HYPERPAY_BALANCE_QUERY_FAILED",
  "HYPERPAY_CARD_CONFIG_NOT_FOUND",
  "HYPERPAY_CARD_CONFIG_FAILED",
  "HYPERPAY_APPLY_PENDING",
  "HYPERPAY_APPLY_INSUFFICIENT_BALANCE",
  "HYPERPAY_APPLY_FREEZE_FAILED",
  "HYPERPAY_KYC_IMAGE_PARAM_INVALID",
  "HYPERPAY_KYC_IMAGE_DOWNLOAD_FAILED",
  "HYPERPAY_KYC_IMAGE_TYPE_INVALID",
  "HYPERPAY_KYC_IMAGE_TOO_LARGE",
  "HYPERPAY_KYC_IMAGE_BASE64_FAILED",
  "HYPERPAY_APPLY_FAILED",
  "HYPERPAY_APPLY_ERROR",
  "HYPERPAY_APPLY_NOT_FOUND",
  "HYPERPAY_APPLY_UNAUTHORIZED",
  "HYPERPAY_ATTACH_STATUS_INVALID",
  "HYPERPAY_ATTACH_UPLOAD_FAILED",
  "HYPERPAY_CARD_NOT_FOUND",
  "HYPERPAY_CARD_BALANCE_FAILED",
  "HYPERPAY_CARD_SENSITIVE_QUERY_FAILED",
  "HYPERPAY_CARD_SENSITIVE_DECRYPT_FAILED",
  "HYPERPAY_CARD_SENSITIVE_KEY_NOT_CONFIGURED",
  "HYPERPAY_CARD_UNAUTHORIZED",
  "HYPERPAY_CARD_OPERATION_FAILED",
  "HYPERPAY_ESTIMATE_FAILED",
  "HYPERPAY_PAY_CURRENCY_UNSUPPORTED",
  "HYPERPAY_EXCHANGE_RATE_FAILED",
  "HYPERPAY_RECHARGE_INSUFFICIENT_BALANCE",
  "HYPERPAY_RECHARGE_FREEZE_FAILED",
  "HYPERPAY_RECHARGE_FAILED",
  "HYPERPAY_RECHARGE_QUERY_FAILED",
  "HYPERPAY_TRANSACTION_QUERY_FAILED",
];

const IGNORED_ERROR_MESSAGES = new Set(["format", "size", "sign_size", "compress", "compress_size", "fetch", "network"]);

export function extractHyperpayMc(error) {
  if (!error) return "";
  const direct = error.mc ?? error.code;
  if (direct) return String(direct).trim();
  const nested = error.response?.data?.mc ?? error.data?.mc;
  return String(nested || "").trim();
}

export function extractHyperpayMa(error) {
  if (!error) return "";
  const ma = error.ma ?? error.response?.data?.ma ?? error.data?.ma;
  if (Array.isArray(ma) && ma.length > 0) return String(ma[0] || "").trim();
  return "";
}

/**
 * 将 HyperPay 接口错误解析为多语言文案（mc 优先，其次 ma / message）
 * @param {Function} t
 * @param {unknown} error
 * @param {string} [fallbackKey]
 */
export function resolveHyperpayErrorMessage(t, error, fallbackKey) {
  const mc = extractHyperpayMc(error);
  if (mc && mc !== "SUCCESS") {
    const byMc = t(mc);
    if (byMc && byMc !== mc) return byMc;
  }

  const ma = extractHyperpayMa(error);
  if (ma) return ma;

  const msg = String(error?.message || "").trim();
  if (msg && !IGNORED_ERROR_MESSAGES.has(msg)) return msg;

  if (fallbackKey) {
    const fallback = t(fallbackKey);
    if (fallback && fallback !== fallbackKey) return fallback;
  }

  const system = t("SYSTEM_ERROR");
  return system && system !== "SYSTEM_ERROR" ? system : "System error";
}
